import { useCallback, useMemo, useState } from 'react';
import { getLocationList, storeLocationList } from '../../utilities/locationList';

export default function useLocationList() {
  const [locationList, setLocationList] = useState(getLocationList());

  const updateLocationList = useCallback(locationList => {
    const builtLocationList = locationList.reduce((prev, current) => {
      return {
        ...prev,
        [current.id]: {
          address: current.Address,
          booking_phone: current.PhoneNumber,
          display: current.Name,
          shortDisplayName: current.Name,
          mobile_booking_phone: current.MobileBookingPhone,
          phone: current.PhoneNumber,
          operaCode: current.id,
          url: current.ShortName,
          region: current.Region,
          birthdayEmail: current.BirthdayEmail,
          maxOccupancy: current.MaxOccupancy
        }
      };
    }, {});
    storeLocationList(builtLocationList);
    setLocationList(builtLocationList);
  }, []);

  const locationsByRegion = useMemo(() => {
    const locationsByRegion = [];
    const regionMap = {};

    Object.values(locationList || {}).forEach(location => {
      const { display, region: regionName, operaCode } = location;
      if (!regionMap[regionName]) {
        regionMap[regionName] = { regionName, locations: [] };
        locationsByRegion.push(regionMap[regionName]);
      }
      regionMap[regionName].locations.push({ display, region: regionName, operaCode });
    });

    return locationsByRegion;
  }, [locationList]);

  const getLocationDataByResortCode = useCallback(
    resortCode => {
      return locationList[resortCode] || {};
    },
    [locationList]
  );

  return {
    locationList,
    updateLocationList,
    locationsByRegion,
    getLocationDataByResortCode
  };
}
